/**
 * Helpers for building the public, path-based uploader URL.
 *
 * The uploader is now a single Firebase Hosting site that resolves the
 * site from the first path segment (e.g. `https://host/<slug>`), so the
 * base origin is shared by every site. Override it per environment with
 * `REACT_APP_UPLOADER_BASE_URL`; it falls back to the default site.
 */
export const UPLOADER_BASE_URL =
  process.env.REACT_APP_UPLOADER_BASE_URL?.replace(/\/+$/, "") ||
  "https://app.raw.gallery";

/** Full public uploader URL for a site slug. */
export function buildUploaderUrl(slug: string): string {
  return `${UPLOADER_BASE_URL}/${slug}`;
}

/** Compact `host/slug` form without the scheme, for inline display. */
export function uploaderDisplayPath(slug: string): string {
  return `${UPLOADER_BASE_URL.replace(/^https?:\/\//, "")}/${slug}`;
}
